export enum CategoryAdditionalMarketingDataPositionEnum {
  Lame_1 = 'LAME_1',
  Lame_2 = 'LAME_2',
  Lame_3 = 'LAME_3',
  Lame_4 = 'LAME_4',
  Lame_5 = 'LAME_5',
  Lame_6 = 'LAME_6',
  Lame_7 = 'LAME_7',
  Lame_8 = 'LAME_8',
  Lame_9 = 'LAME_9',
  Lame_10 = 'LAME_10',
  Lame_11 = 'LAME_11',
  Lame_12 = 'LAME_12'
}
